import FontFaceObserver from 'fontfaceobserver'
import { fonts } from 'settings/custom/fonts'

const name = 'FONTS'

function toPromise([family, variants]) {
  return variants.map((variant) => new FontFaceObserver(family, variant).load())

}

async function execute() {
  return new Promise((resolve) => {
    Promise.all(Object.entries(fonts).flatMap(toPromise))
      .then(resolve, resolve)
  })
}

export function getFontsAction() {
  return {
    name,
    execute,
  }
}
